import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { ApiUrl } from "../components/API/Api";

const SiteDataContext = createContext(null);

export const SiteDataProvider = ({ children }) => {
  const [homedata, setHomedata] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const fetchSiteData = async () => {
      try {
        const response = await axios.get(`${ApiUrl}/get/homepagee/sections`);
        if (isMounted && response?.data?.data) {
          setHomedata(response.data.data);
        }
      } catch (err) {
        console.error("Error fetching site data:", err);
        if (isMounted) setError(err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchSiteData();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <SiteDataContext.Provider value={{ homedata, loading, error }}>
      {children}
    </SiteDataContext.Provider>
  );
};

export const useSiteData = () => {
  const context = useContext(SiteDataContext);
  if (!context) {
    throw new Error("useSiteData must be used within a SiteDataProvider");
  }
  return context;
};
